import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderPostHist extends Layout {
    sourceOrderPostHist: DataSource;
    sourceQuotePostHist: DataSource;
    tableOrderPostHist: Table;
}
